module.exports = __webpack_public_path__ + "img/MINI_headerbanner.988c444f.png";